import type { SessionStorageKey } from './types.ts';

export function serializeSessionStorageKey(args: SessionStorageKey): string {
  if (args.version != null) {
    return `${args.key}-v${args.version}`;
  }
  return args.key;
}
